<template>
    <el-container>
      <div class="w100 center flex-center" style="text-align: center;zoom: 1.5;padding-top:20px;">
        <div class="qr-code22"  ref="urlQrCode"></div> <br>

      </div>
      <div style="position: absolute;bottom: 20px;left:50%;margin-left:-60px;zoom: 3;">
        <div class="download-btn"><el-button class="btn" type="primary" @click="savePic">下载二维码</el-button></div>
      </div>

    </el-container>
</template>

<script>
import QRCode from 'qrcodejs2';
    export default {
        name: "telegramAuth",
        data() {
            return {
                web_token: '',
                url:'',
            }
        },
        mounted() {
          console.log(this.$route.query);
          const query=this.$route.query;
          const url=decodeURIComponent(query.url);
          this.url=url;
          new QRCode(this.$refs.urlQrCode, {
            text: url,
            width: 500,
            height: 500,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });

        },
        methods:{
          savePic() {
            let myQrCode = this.$refs.urlQrCode.getElementsByTagName('canvas');
            let a = document.createElement('a');
            a.href = myQrCode[0].toDataURL('image/png');
            a.download = this.url;
            a.click();
          },


        },
        components: {
        },
    }
</script>
